import React from "react";
import ihrLogo from "../../../../static/img/img-ihr-name-logo-black.svg";
import { ReactComponent as ProfileIcon } from "../../icons/profile.svg";

type PremiumCheckoutHeaderProps = {
    emailDisplay?: string;
};

const PremiumCheckoutHeader: React.FC<PremiumCheckoutHeaderProps> = ({
    emailDisplay = "",
}) => {
    return (
        <header
            className="PremiumCheckoutHeader"
            role="banner"
            aria-label="Account"
        >
            <img
                src={ihrLogo}
                alt="Instant Heart Rate"
                className="PremiumCheckoutHeader__brand"
            />
            <div className="PremiumCheckoutHeader__right">
                <ProfileIcon className="PremiumCheckoutHeader__icon" />
                {emailDisplay ? (
                    <span className="PremiumCheckoutHeader__email">
                        {emailDisplay}
                    </span>
                ) : null}
            </div>
        </header>
    );
};

export default PremiumCheckoutHeader;
